import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash';

import InputFeedback from './InputFeedback';

const MonetaryInput = ({
  field, form: { touched, errors }, label, className, ...props
}) => {
  const { name } = field;
  const error = _.get(touched, name) && _.get(errors, name);

  const classes = classnames(
    'input-group monetary-group field has-addons',
    { error: !!error },
    className
  );
  const inputClasses = classnames('text-input input', { 'is-danger': !!error });

  return (
    <div className={classes}>
      <label htmlFor={name} className="label">
        {label}
      </label>
      <div className="control">
        <span className="button is-static">$</span>
      </div>
      <div className="control">
        <input type="number" className={inputClasses} id={name} {...field} {...props} />
      </div>
      <InputFeedback error={error} />
    </div>
  );
};

MonetaryInput.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  form: PropTypes.shape({
    touched: PropTypes.object,
    errors: PropTypes.object,
  }).isRequired,
  label: PropTypes.string,
  className: PropTypes.string,
  autoComplete: PropTypes.string,
};

MonetaryInput.defaultProps = {
  label: '',
  className: '',
  autoComplete: 'on',
};

export default MonetaryInput;



// WEBPACK FOOTER //
// ./src/components/common/form/MonetaryInput.jsx